/**
 * Label + pill style for a monthly check-in status. Case-insensitive because the check-in list
 * endpoint returns the enum lower-cased while the members list returns it upper-cased.
 */
const getCheckinStatus = (status?: string | null): { label: string; className: string } => {
    switch (status?.toLowerCase()) {
        case 'not_done':
        case 'user_confirmed_checkin':
            return { label: 'Overdue', className: 'overdue' };
        case 'complete':
            return { label: 'Completed', className: 'completed' };
        case 'due_last_day':
            return { label: 'Due (last day)', className: 'due' };
        default:
            return { label: 'Due', className: 'due' };
    }
};

export default getCheckinStatus;
